import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { makeApiCall } from '../../services/httpService';
import { BASE_URL } from '../../config';
import toast from 'react-hot-toast';
import DContext from '../../context/DContext';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ContentLoader from '../loader/ContentLoader';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useLoadingBar } from 'react-top-loading-bar';

const VendorList = () => {
  const { start, complete } = useLoadingBar({ color: "blue", height: 2 });
  const location = useLocation();
  const { authState, authDispatch, logout } = useContext(DContext);
  const { user } = authState;
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false)
    setVendorDetail(initialVendorDetail);
  }

  const handleShow = () => {
    setShow(true)
  }

  const [pincodeDropdown, setPincodeDropdown] = useState({
    cities: [],
    states: [],
    districts: []
  });

  const initialVendorDetail = {
    id: null,
    company_name: "",
    executive: "",
    email: "",
    mobile_number: "",
    address: "",
    city: "",
    state: "",
    country: "India",
    pincode: ""
  };
  const [vendorDetail, setVendorDetail] = useState(initialVendorDetail);
  const [pageValue, setPageValue] = useState(1);
  const [pagingLimit, setPagingLimit] = useState("10");
  const [vendors, setVendors] = useState({
    paginationInfo: {},
    vendorList: []
  })

  const initialVendorSearch = { company_name: null, id: null, email: null, mobile_number: null };
  const [vendorSearch, setVendorSearch] = useState(initialVendorSearch);
  const [btnVendorSearchDisabled, setVendorSearchBtnDisabled] = useState(true);
  const [btnVendorSearchText, setVendorSearchBtnText] = useState("Search");
  //const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  //vendor add update section
  const [addUpdateVendorHeading, setAddUpdateVendorHeading] = useState('Add New');
  const [btnAddUpdateVendorText, setBtnAddUpdateVendorText] = useState('Save');



  useEffect(() => {
    loadVendors();
  }, [pagingLimit, pageValue]);


  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }

  const loadVendors = async () => {
    try {
      setLoading(true);
      start();
      let apiUrl = `${BASE_URL}/api/vendors?page=${pageValue}&limit=${pagingLimit}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      //console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        setVendors({
          paginationInfo: apiRes.resData?.pagination,
          vendorList: apiRes.resData?.vendors
        })
      } else {
        // console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      // console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
      complete();
    }
  }

  const loadPincodeInfo = async (pincode) => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/pincode?pin=${pincode}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      //console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setPincodeDropdown(apiRes?.resData);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
        //showSwal("Error",apiRes.message,"error")
      }
    } catch (err) {
      // console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }


  const handlePagingLimit = (e) => {
    setPageValue(1);
    setPagingLimit(e.target.value);
  }

  const handlePagination = (pageValueInput) => {
    setPageValue(pageValueInput);
  }

  const handleChange = (e) => {
    //console.log("change detected", e.target.name);
    setVendorDetail({ ...vendorDetail, [e.target.name]: e.target.value });
  }

  const handlePincodeChange = async (e) => {
    const pincodeValue = e.target.value;
    setVendorDetail({ ...vendorDetail, pincode: pincodeValue })
    if (pincodeValue.length === 6) {
      const pincodeData = await loadPincodeInfo(pincodeValue);
      if (pincodeData) {
        // Update dropdown data
        setPincodeDropdown(pincodeData);
        // Auto-set city & state in vendorDetail so form state is updated
        setVendorDetail((prev) => ({
          ...prev,
          pincode: pincodeValue,
          city: pincodeData.cities?.[0]?.city || "",
          state: pincodeData.states?.[0]?.state || ""
        }));
      }
    }
  }

  const handleUpdateVendor = (vendorArgs) => {
    setAddUpdateVendorHeading('Update');
    setBtnAddUpdateVendorText('Update');
    //console.log(vendorArgs);
    setShow(true);
    loadPincodeInfo(vendorArgs?.pincode)
    setVendorDetail(vendorArgs);

  }

  useEffect(() => {
    console.log("vendorDetail updated:", vendorDetail);
  }, [vendorDetail]);

  // Swal confirmation box start
  const handleInactivateVendor = async (vendorId, vendorRoleId, vendorStatus) => {
    customShowSwal(
      "Are you sure?",
      `Are you sure you want to ${vendorStatus} this vendor?`,
      "warning",
      () => {
        // ✅ only runs if user clicks Yes
        //console.log("Vendor inactivated:", vendorId);
        // 👉 here call your API or function
        // makeApiCall("POST", { vendorId }, "/api/vendor/inactive");
        toggleVendorStatus(vendorId, vendorRoleId, vendorStatus);
      }
    );
  };

  const customShowSwal = (title, text, icon, onConfirm) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon, // 'success' | 'error' | 'warning' | 'info' | 'question'
      showCancelButton: true,       // show No button
      confirmButtonText: "Yes",     // text for Yes
      cancelButtonText: "No",       // text for No
    }).then((result) => {
      if (result.isConfirmed) {
        if (onConfirm) onConfirm(); // ✅ run your code if Yes
      }
      // ❌ if No → popup auto closes, nothing happens
    });
  };

  const toggleVendorStatus = async (vendorId, vendorRoleId, vendorStatus) => {
    try {
      setLoading(true);
      let bodyPayload = { user_id: vendorId, role_id: vendorRoleId, status: vendorStatus };
      //console.log("body payload", bodyPayload);
      let apiUrl = `${BASE_URL}/api/users/toggle-status`;
      let apiRes = await makeApiCall("POST", bodyPayload, apiUrl);
      //console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        toast.success(apiRes.message);
      } else {
        //console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      //console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
      loadVendors();
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (vendorDetail.id === null) {
      SaveVendorDetails();
    }
    else {
      UpdateVendorDetails();
    }
  }

  const SaveVendorDetails = async () => {
    try {
      //setModalLoading(true);
      let bodyPayload = {};

      bodyPayload['name'] = vendorDetail.executive;
      bodyPayload['phone'] = vendorDetail.mobile_number;
      bodyPayload['email'] = vendorDetail.email;
      bodyPayload['password'] = "hello@123";
      bodyPayload['role_code'] = 1006; //vendor rolecode
      bodyPayload['profile_info'] = vendorDetail;
      //console.log("final form data", bodyPayload);
      let apiUrl = `${BASE_URL}/api/users`;
      let apiRes = await makeApiCall("POST", bodyPayload, apiUrl);
      //console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        setShow(false);
        setVendorDetail(initialVendorDetail);
        loadVendors();
      } else {
        //console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      //setModalLoading(false);
      setAddUpdateVendorHeading('Add New');
      setBtnAddUpdateVendorText('Save');
    }
  }

  const UpdateVendorDetails = async () => {
    try {
      let bodyPayload = {};
      bodyPayload['role_id'] = vendorDetail.roleId;
      bodyPayload['role'] = "vendor";
      bodyPayload['company_name'] = vendorDetail.company_name;
      bodyPayload['executive'] = vendorDetail.executive;
      bodyPayload['email'] = vendorDetail.email;
      bodyPayload['mobile_number'] = vendorDetail.mobile_number;
      bodyPayload['address'] = vendorDetail.address;
      bodyPayload['city'] = vendorDetail.city;
      bodyPayload['state'] = vendorDetail.state;
      bodyPayload['country'] = vendorDetail.country;
      bodyPayload['pincode'] = vendorDetail.pincode;

      let apiUrl = `${BASE_URL}/api/users/${vendorDetail.user_id}`;
      let apiRes = await makeApiCall("PATCH", bodyPayload, apiUrl);

      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        setShow(false);
        setVendorDetail(initialVendorDetail);
        loadVendors();
      } else {
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      //setModalLoading(false);
      setAddUpdateVendorHeading('Add New');
      setBtnAddUpdateVendorText('Save');
    }
  }

  // filter section start  
  const onClickSearch = async () => {
    try {
      setVendorSearchBtnDisabled(true);
      setVendorSearchBtnText(<>
        <span className="loading-text">
          {/* Searching */}
          <span className="dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </span></>);
      start();
      let apiUrl = `${BASE_URL}/api/users/all-users?&page=${pageValue}&limit=${pagingLimit}`;
      let payload = {
        userType: "vendor",
        userStatus: "all",
        searchFeature: true,
        searchObj: vendorSearch
      }
      //console.log(payload);

      //await delay(2000); // wait 2 seconds 
      let apiRes = await makeApiCall("POST", payload, apiUrl);
      if (apiRes?.statusCode === 200) {
        setVendors({
          paginationInfo: apiRes.resData?.paginationInfo,
          vendorList: apiRes.resData?.users
        });
      }
      else {
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error");
        }
        else {
          toast.error(apiRes.message);
        }
      }
    } catch (error) {
      showSwal("Error", "Something went wrong...", "error");
    }
    finally {
      setVendorSearchBtnText("Search");
      setVendorSearchBtnDisabled(false);
      complete();
    }
  }

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setVendorSearch((prev) => ({
      ...prev,
      [name]: value.trim() === "" ? null : value
    }));
  };

  useEffect(() => {
    // check if any field in vendorSearch has a non-null value
    const hasValue = Object.values(vendorSearch).some((val) => val !== null && val !== "");
    setVendorSearchBtnDisabled(!hasValue);
  }, [vendorSearch]);

  const onClickSearchReset = () => {
    setVendorSearch(initialVendorSearch);
    loadVendors();
  }

  return (
    <>
      <section className="section dashboard">

        {/* Search Filter Card */}
        <div className="row mb-3">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
              <div className="card-body p-3">
                <form onSubmit={onClickSearch}>
                  <div className="row g-2 align-items-end">

                    {[
                      { id: "txtVendorNameSearch", label: "Company Name", name: "company_name", icon: "bi-building", value: vendorSearch?.company_name, col: 3 },
                      { id: "txtVendorIdSearch", label: "Vendor ID", name: "id", icon: "bi-upc", value: vendorSearch?.id, col: 2 },
                      { id: "txtVendorMobileSearch", label: "Mobile", name: "mobile_number", icon: "bi-telephone", value: vendorSearch?.mobile_number, col: 2 },
                      { id: "txtVendorEmailSearch", label: "Email", name: "email", icon: "bi-envelope", value: vendorSearch?.email, col: 3 },
                    ].map(({ id, label, name, icon, value, col }) => (
                      <div className={`col-md-${col}`} key={id}>
                        <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                            <i className={`bi ${icon}`} style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id={id}
                            placeholder={label}
                            name={name}
                            onChange={handleSearchChange}
                            value={value || ""}
                            style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }}
                          />
                        </div>
                      </div>
                    ))}

                    <div className="col-md-2 d-flex gap-2">
                      <button
                        type="submit"
                        onClick={onClickSearch}
                        className="btn btn-sm text-white fw-semibold flex-grow-1 d-flex align-items-center justify-content-center gap-1"
                        disabled={btnVendorSearchDisabled}
                        style={{
                          background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                          borderRadius: "8px", border: "none",
                          boxShadow: "0 3px 10px rgba(15,37,87,0.25)",
                          fontSize: "13px", height: "34px"
                        }}
                      >
                        <i className="fa-solid fa-magnifying-glass"></i> {btnVendorSearchText}
                      </button>
                      <button
                        type="button"
                        onClick={onClickSearchReset}
                        className="btn btn-sm d-flex align-items-center justify-content-center"
                        style={{
                          background: "#f0f0f0", border: "1.5px solid #dde3ef",
                          borderRadius: "8px", color: "#6c757d",
                          fontSize: "13px", height: "34px", width: "34px", flexShrink: 0
                        }}
                        title="Reset"
                      >
                        <i className="fa-solid fa-xmark"></i>
                      </button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", overflow: "hidden" }}>
              <div className="card-body pb-0 p-3">

                {/* Table Header */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <div style={{
                      width: "32px", height: "32px", borderRadius: "8px",
                      background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                      display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                      <i className="bi bi-shop text-white" style={{ fontSize: "14px" }}></i>
                    </div>
                    <div>
                      <span className="fw-bold" style={{ color: "#2d3748", fontSize: "15px" }}>Vendor List</span>
                      <span className="ms-2 badge rounded-pill" style={{ background: "#eef0ff", color: "#1a3a8f", fontSize: "11px", fontWeight: "600" }}>
                        {vendors?.paginationInfo?.totalRecords} Records
                      </span>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm text-white fw-semibold d-flex align-items-center gap-2 px-3"
                    onClick={handleShow}
                    style={{
                      background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                      borderRadius: "8px", border: "none",
                      boxShadow: "0 3px 10px rgba(15,37,87,0.25)",
                      fontSize: "13px"
                    }}
                  >
                    <i className="bi bi-person-fill-add"></i> Add New Vendor
                  </button>
                </div>

                {/* Table */}
                <div style={{ position: "relative" }}>
                  {loading && (
                    <div style={{
                      position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                      background: "rgba(255,255,255,0.7)", display: "flex",
                      justifyContent: "center", alignItems: "center", zIndex: 10,
                      borderRadius: "10px"
                    }}>
                      <ContentLoader loaderType="circleSpin" />
                    </div>
                  )}
                  <div className="table-responsive" style={{ height: "calc(100vh - 380px)" }}>
                    <table className="table table-hover mb-0" style={{ fontSize: "13px" }}>
                      <thead>
                        <tr style={{ background: "#f8f9fe" }}>
                          {["Vendor Id", "Company", "Executive", "Mobile", "Email", "Address", "City", "State", "Pincode", ""].map((h, i) => (
                            <th key={i} style={{
                              fontSize: "11px", fontWeight: "700", color: "#8a9ab5",
                              textTransform: "uppercase", letterSpacing: "0.6px",
                              borderBottom: "2px solid #e8edf5", padding: "10px 12px",
                              whiteSpace: "nowrap", background: "#f8f9fe"
                            }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {vendors?.vendorList?.length > 0 ? (
                          vendors.vendorList.map((vendor, index) => (
                            <tr key={index} style={{ borderBottom: "1px solid #f0f4f8", transition: "background 0.15s" }}
                              onMouseEnter={e => e.currentTarget.style.background = "#f8f9fe"}
                              onMouseLeave={e => e.currentTarget.style.background = "white"}
                            >
                              <td style={{ padding: "10px 12px", color: "#4a5568" }}>
                                <span className="badge" style={{ background: "#eef0ff", color: "#1a3a8f", fontWeight: "600", fontSize: "12px" }}>
                                  {vendor?.vendor_code}
                                </span>
                              </td>
                              <td style={{ padding: "10px 12px", fontWeight: "600", color: "#2d3748" }}>{vendor?.company_name}</td>
                              <td style={{ padding: "10px 12px", color: "#4a5568" }}>{vendor?.executive}</td>
                              <td style={{ padding: "10px 12px", color: "#4a5568" }}>{vendor?.mobile}</td>
                              <td style={{ padding: "10px 12px", color: "#4a5568" }}>{vendor?.email}</td>
                              <td style={{ padding: "10px 12px", color: "#6c757d", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{vendor?.address}</td>
                              <td style={{ padding: "10px 12px", color: "#4a5568" }}>{vendor?.city}</td>
                              <td style={{ padding: "10px 12px", color: "#4a5568" }}>{vendor?.state}</td>
                              <td style={{ padding: "10px 12px", color: "#4a5568" }}>{vendor?.pincode}</td>
                              <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                                <button
                                  className="btn btn-sm me-1"
                                  onClick={() => handleUpdateVendor(vendor)}
                                  style={{ background: "#eef0ff", border: "none", borderRadius: "6px", color: "#1a3a8f", width: "30px", height: "30px", padding: 0 }}
                                  title="Edit"
                                >
                                  <i className="bi bi-pencil-fill" style={{ fontSize: "12px" }}></i>
                                </button>
                                {vendor?.status === "active" ? (
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => handleInactivateVendor(vendor?.userId, vendor?.roleId, "inactive")}
                                    style={{ background: "#fff5f5", border: "none", borderRadius: "6px", color: "#e53e3e", width: "30px", height: "30px", padding: 0 }}
                                    title="Deactivate"
                                  >
                                    <i className="bi bi-trash-fill" style={{ fontSize: "12px" }}></i>
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => handleInactivateVendor(vendor?.userId, vendor?.roleId, "active")}
                                    style={{ background: "#f0fff4", border: "none", borderRadius: "6px", color: "#38a169", width: "30px", height: "30px", padding: 0 }}
                                    title="Activate"
                                  >
                                    <i className="bi bi-arrow-counterclockwise" style={{ fontSize: "12px" }}></i>
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center py-5" style={{ color: "#adb5bd" }}>
                              <i className="bi bi-inbox" style={{ fontSize: "32px", display: "block", marginBottom: "8px" }}></i>
                              No vendors found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination */}
                <div className="table-pagination-without-padding">
                  <div className="dataTables_info d-flex align-items-center gap-2" role="status">
                    <select
                      className="form-select form-select-sm"
                      id="paginationRows"
                      onChange={handlePagingLimit}
                      style={{ width: "70px", borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}
                    >
                      {["10", "20", "50", "100", "500"].map(v => (
                        <option value={v} key={v} selected={pagingLimit === v}>{v}</option>
                      ))}
                    </select>
                    <span style={{ fontSize: "12px", color: "#8a9ab5" }}>per page</span>
                  </div>

                  <div className="dataTables_paginate paging_simple_numbers">
                    <ul className="pagination mb-0" style={{ gap: "4px" }}>
                      <li className={`paginate_button page-item ${pageValue === 1 ? "disabled" : ""}`}>
                        <Link className="page-link" onClick={() => handlePagination(pageValue - 1)}
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "13px" }}>
                          <i className="fa-solid fa-angle-left"></i>
                        </Link>
                      </li>
                      {Array.from({ length: vendors?.paginationInfo?.totalPage }, (_, i) => (
                        <li className={`paginate_button page-item ${pageValue === i + 1 ? "active" : ""}`} key={i}>
                          <Link className="page-link" onClick={() => handlePagination(i + 1)}
                            style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}>
                            {i + 1}
                          </Link>
                        </li>
                      ))}
                      <li className={`paginate_button page-item ${pageValue === vendors?.paginationInfo?.totalPage ? "disabled" : ""}`}>
                        <Link className="page-link" onClick={() => handlePagination(pageValue + 1)}
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "13px" }}>
                          <i className="fa-solid fa-angle-right"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </section>

      <Modal size="lg" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton style={{ border: "none", padding: "20px 24px 0" }}>
          <div className="d-flex align-items-center gap-3">
            <div style={{
              width: "40px", height: "40px", borderRadius: "10px",
              background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
            }}>
              <i className="bi bi-shop text-white" style={{ fontSize: "18px" }}></i>
            </div>
            <div>
              <Modal.Title style={{ fontSize: "17px", fontWeight: "700", color: "#0f2557", lineHeight: 1.2 }}>
                {addUpdateVendorHeading} Vendor
              </Modal.Title>
              <p className="mb-0" style={{ fontSize: "12px", color: "#8a9ab5" }}>Fill in the vendor details below</p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: "20px 24px 24px" }}>
          {modalLoading ? <ContentLoader loaderType="circleSpin" /> : (
            <form onSubmit={handleSubmit}>

              {/* Section: Company Info */}
              <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #e8edf5" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-building" style={{ color: "#1a3a8f", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3a8f", textTransform: "uppercase", letterSpacing: "0.7px" }}>Company Info</span>
                </div>
                <div className="row g-2">
                  {[
                    { id: "txtVendorCompanyName", label: "Company Name", name: "company_name", icon: "bi-building", value: vendorDetail?.company_name, col: 4 },
                    { id: "txtExecutive", label: "Executive Name", name: "executive", icon: "bi-person-badge", value: vendorDetail?.executive, col: 4 },
                    { id: "txtVendorEmail", label: "Email", name: "email", icon: "bi-envelope", value: vendorDetail?.email, col: 4 },
                    { id: "txtVendorMobile", label: "Mobile", name: "mobile_number", icon: "bi-telephone", value: vendorDetail?.mobile_number, col: 3 },
                    { id: "txtAddress", label: "Address", name: "address", icon: "bi-map", value: vendorDetail?.address, col: 9 },
                  ].map(({ id, label, name, icon, value, col }) => (
                    <div className={`col-md-${col}`} key={id}>
                      <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                          <i className={`bi ${icon}`} style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                        </span>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id={id}
                          placeholder={label}
                          name={name}
                          onChange={handleChange}
                          value={value || ""}
                          style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Section: Location */}
              <div className="p-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #e8edf5" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-geo-alt-fill" style={{ color: "#1a3a8f", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3a8f", textTransform: "uppercase", letterSpacing: "0.7px" }}>Location</span>
                </div>
                <div className="row g-2 align-items-end">

                  {/* Pincode */}
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>Pin Code</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-pin-map" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="txtPinCode"
                        placeholder="Pin Code"
                        name="pincode"
                        onChange={handlePincodeChange}
                        value={vendorDetail?.pincode || ""}
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                      />
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>City</label>
                    <select
                      className="form-select form-select-sm"
                      id="txtCity"
                      name="city"
                      onChange={handleChange}
                      value={vendorDetail?.city || ""}
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: "white", fontSize: "13px" }}
                    >
                      {pincodeDropdown?.cities?.map(e => (
                        <option value={e.city} key={e.city}>{e.city}</option>
                      ))}
                    </select>
                  </div>

                  {/* State */}
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>State</label>
                    <select
                      className="form-select form-select-sm"
                      id="txtState"
                      name="state"
                      onChange={handleChange}
                      value={vendorDetail?.state || ""}
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: "white", fontSize: "13px" }}
                    >
                      {pincodeDropdown?.states?.map(e => (
                        <option value={e.state} key={e.state}>{e.state}</option>
                      ))}
                    </select>
                  </div>

                  {/* Submit */}
                  <div className="col-md-3 d-flex justify-content-end">
                    <button
                      type="submit"
                      className="btn btn-sm text-white fw-semibold d-flex align-items-center gap-2 px-4 w-100 justify-content-center"
                      style={{
                        background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                        borderRadius: "8px", border: "none",
                        boxShadow: "0 4px 12px rgba(15,37,87,0.3)",
                        fontSize: "13px", height: "34px"
                      }}
                    >
                      <i className="bi bi-floppy-fill"></i> {btnAddUpdateVendorText} Vendor
                    </button>
                  </div>

                </div>
              </div>

            </form>
          )}
        </Modal.Body>
      </Modal>

    </>
  )
}

export default VendorList